import React from "react";
import SearchVoiceItem from "./SearchVoiceItem";
import VoiceImage from "../VoiceImage";
import { Checkbox } from "@jammable/ui-core";
import NotFound from "../../../../apps/web/components/NotFound";
const SearchVoiceSection = ({
  voices,
  subtitle,
  limit,
  isLoading,
  addVoice,
  selectedVoices,
  isCombo,
  selectCombo,
}) => {
  return (
    <div>
      {subtitle !== "SEARCH RESULTS" && (
        <div className="tw-font-black tw-tracking-widest tw-text-xs tw-text-black/40 tw-mt-4 tw-mb-1">
          {subtitle}
        </div>
      )}

      <div className="tw-grid tw-max-h-72 tw-min-h-72 md:tw-min-h-max md:tw-h-max tw-items-cneter tw-overflow-y-scroll md:tw-grid-cols-2 tw-grid-cols-1 tw tw-justify-center tw-gap-2">
        {voices?.length === 0 && (
          <div className="tw-w-full tw-col-span-full tw-h-full tw-flex tw-items-center tw-justify-center">
            <NotFound
              animateIn={false}
              title={`No ${subtitle.toLowerCase()} found...`}
              buttonText={"Create your own voice!"}
              buttonLink={"/train"}
            />
          </div>
        )}
        {isLoading
          ? isCombo
            ? [...Array(limit)].map((_, index) => (
                <div
                  key={index}
                  className="tw-w-full tw-h-max tw-flex tw-flex-col tw-p-3 tw-gap-2 tw-rounded-2xl tw-bg-gray-100 tw-animate-pulse"
                >
                  <div className="tw-w-14 tw-h-3 tw-rounded-2xl tw-bg-gray-200" />

                  <div className="tw-flex tw-gap-1">
                    <div className="tw-h-12 tw-w-12 tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>
                    <div className="tw-h-12 tw-w-12 tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>
                  </div>
                  <div className="tw-flex tw-flex-col tw-gap-2 tw-h-auto tw-justify-between ">
                    <div className="tw-w-32 tw-h-3 tw-rounded-2xl tw-bg-gray-200" />
                  </div>
                </div>
              ))
            : [...Array(limit)].map((_, index) => (
                <div
                  key={index}
                  className="tw-w-full tw-h-14 tw-flex tw-p-2 tw-gap-2 tw-rounded-2xl tw-bg-gray-100 tw-animate-pulse"
                >
                  <div className="tw-h-full tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>

                  <div className="tw-flex tw-flex-col tw-h-auto tw-justify-between tw-py-1">
                    <div className="tw-w-14 tw-h-3 tw-rounded-2xl tw-bg-gray-200" />
                    <div className="tw-w-32 tw-h-3 tw-rounded-2xl tw-bg-gray-200" />
                  </div>
                </div>
              ))
          : null}

        {voices?.slice(0, limit).map((voice) => {
          let artistNames;
          if (voice?.models && voice.models.length > 0) {
            const names = voice.models.map((model) => model.artistname);
            if (names.length > 1) {
              artistNames =
                names.slice(0, -1).join(", ") + " & " + names[names.length - 1];
            } else {
              artistNames = names[0];
            }
          }

          const isComboSelected = isCombo
            ? selectedVoices.length === voice.models.length &&
              voice.models.every((model) =>
                selectedVoices.some((v) => v._id === model._id),
              )
            : null;

          return isLoading ? (
            isCombo ? (
              <div
                className={`tw-w-full tw-h-20 tw-flex tw-p-4 tw-gap-2 tw-rounded-2xl tw-bg-gray-100 tw-animate-pulse`}
              >
                <div className="tw-h-full tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>
                <div className="tw-h-full tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>
                <div className="tw-h-full tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>
              </div>
            ) : (
              <div
                className={`tw-w-full tw-h-14 tw-flex tw-p-2 tw-gap-2 tw-rounded-2xl tw-bg-gray-100 tw-animate-pulse`}
              >
                <div className="tw-h-full tw-aspect-square tw-rounded-xl tw-bg-gray-200"></div>

                <div className="tw-flex tw-flex-col tw-h-auto tw-justify-between tw-py-1">
                  <div className="tw-w-14 tw-h-3 tw-rounded-2xl tw-bg-gray-200" />
                  <div className="tw-w-32 tw-h-3 tw-rounded-2xl tw-bg-gray-200" />
                </div>
              </div>
            )
          ) : isCombo ? (
            <div
              onClick={() => {
                selectCombo(voice, isComboSelected);
              }}
              className={`tw-flex tw-flex-col tw-h-max tw-rounded-2xl tw-p-3 tw-items-start tw-justify-start tw-border tw-border-solid tw-border-gray-200 tw-shadow hover:tw-bg-gray-50 tw-transition-all tw-cursor-pointer ${
                isComboSelected &&
                "tw-border-purple-700 tw-bg-purple-50 hover:tw-bg-purple-100"
              }`}
            >
              <div className="tw-text-xs tw-font-black tw-tracking-widest tw-text-black/40">
                {voice.count} USES
              </div>
              <div className="tw-fle">
                {voice?.models?.map((model, index) => {
                  return (
                    <VoiceImage
                      key={model?._id}
                      style={{
                        marginLeft: index === 0 ? 0 : -20,
                      }}
                      model={model}
                      size={50}
                      className="tw-rounded-2xl tw-border-4 tw-shadow tw-border-solid tw-border-white"
                    />
                  );
                })}
              </div>

              <div className="tw-text-sm tw-font-bold tw-text-left tw-w-full tw-text-black/40">
                {artistNames}
              </div>
            </div>
          ) : (
            <SearchVoiceItem
              model={voice}
              key={voice?._id}
              addVoice={addVoice}
              isSelected={selectedVoices.some((v) => v._id === voice._id)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SearchVoiceSection;
